import { atomWithStorage } from 'jotai/utils';

// Use as sesssion storage so that the value is cleared when the tab is closed
export const userClickSSULinkAtom = atomWithStorage<boolean>(
  'userClickSSULink',
  false
);
